module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/target01-14ac2793445a009c463b42123c72b278.png";